import React from 'react';
import DashboardMyDriveContainer from './DashboardMyDriveContainer';

const DashboardPresenter: React.FC = () => {
  return <DashboardMyDriveContainer />;
};

export default DashboardPresenter;
